import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { PinPendingChecklist } from "models";

export const useDeletePinPendingChecklistMutation = () =>
  useTypedMutation<PinPendingChecklist, void>({
    mutationFn: async payload => (await ApiInstance.post("/pin_pending_checklists/delete", payload, ENV.dealerBaseURL)).data,
    onSuccess: ({ checklist_id, pin_type }) => {
      const pinPendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.pinPendingChecklists);
      if (!pinPendingChecklists?.length) return;

      const pinPendingChecklistIdx = pinPendingChecklists.findIndex(p => p.checklist_id === checklist_id && p.pin_type === pin_type);
      if (pinPendingChecklistIdx === -1) return;

      typedQueryClient.setQueryData(PendingChecklistsQueryKeys.pinPendingChecklists, pinPendingChecklists.toSpliced(pinPendingChecklistIdx, 1));
    }
  });
